module.exports = __webpack_public_path__ + "img/2.35c2ff78.png";